// TermsOfService.js
import React from "react";
import "./TermsOfService.css"; // Create and style as needed

function TermsOfService() {
  return (
    <div className="tos-container">
      <h1>Terms of Service</h1>
      <p>Last updated: January 4, 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to Avro! These Terms of Service ("Terms") govern your use of
          our mobile application ("App"). By accessing or using the App, you
          agree to be bound by these Terms. If you do not agree to these Terms,
          please do not use the App.
        </p>
      </section>

      <section>
        <h2>2. User Accounts</h2>
        <p>
          To access certain features of the App, you may need to create an
          account. You are responsible for maintaining the confidentiality of
          your account information and for all activities that occur under your
          account.
        </p>
      </section>

      <section>
        <h2>3. Privacy and Data Collection</h2>
        <p>
          We value your privacy. By using the App, you consent to the
          collection, storage, and use of your data as described in our{" "}
          <a href="/PrivacyPolicy">Privacy Policy</a>.
        </p>
      </section>

      <section>
        <h2>4. Access to Your Data</h2>
        <p>
          By using Avro, you grant us permission to access and store the
          following data:
        </p>
        <ul>
          <li>
            <strong>Food Images:</strong> Any food images you upload to track
            your diet.
          </li>
          <li>
            <strong>Diet Logs:</strong> Records of your daily food intake,
            nutritional information, and meal plans.
          </li>
          <li>
            <strong>Workout Logs:</strong> Details of your exercise routines,
            performance metrics, and progress over time.
          </li>
        </ul>
        <p>
          We use this data to provide personalized workout and diet
          recommendations, track your progress, and enhance your overall
          experience with the App.
        </p>
      </section>

      <section>
        <h2>5. Use of the App</h2>
        <p>
          You agree to use the App only for lawful purposes and in accordance
          with these Terms. You are responsible for all activities that occur
          under your account.
        </p>
      </section>

      <section>
        <h2>6. Intellectual Property</h2>
        <p>
          All content, features, and functionality of the App are the exclusive
          property of Avro and are protected by international copyright,
          trademark, patent, trade secret, and other intellectual property or
          proprietary rights laws.
        </p>
      </section>

      <section>
        <h2>7. Termination</h2>
        <p>
          We may terminate or suspend your account and access to the App at our
          sole discretion, without prior notice or liability, for any reason
          whatsoever, including if you breach these Terms.
        </p>
      </section>

      <section>
        <h2>8. Disclaimer of Warranties</h2>
        <p>
          The App is provided on an "AS IS" and "AS AVAILABLE" basis. Avro
          disclaims all warranties of any kind, whether express or implied,
          including but not limited to the implied warranties of
          merchantability, fitness for a particular purpose, and
          non-infringement.
        </p>
      </section>

      <section>
        <h2>9. Limitation of Liability</h2>
        <p>
          In no event shall Avro, nor its directors, employees, partners, or
          affiliates, be liable for any indirect, incidental, special,
          consequential, or punitive damages, including without limitation, loss
          of profits, data, use, goodwill, or other intangible losses, resulting
          from (i) your access to or use of or inability to access or use the
          App; (ii) any conduct or content of any third party on the App; (iii)
          any content obtained from the App; and (iv) unauthorized access, use,
          or alteration of your transmissions or content.
        </p>
      </section>

      <section>
        <h2>10. Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the
          laws of [Your Country/State], without regard to its conflict of law
          provisions.
        </p>
      </section>

      <section>
        <h2>11. Changes to Terms</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace
          these Terms at any time. If a revision is material, we will provide at
          least 30 days' notice prior to any new terms taking effect. What
          constitutes a material change will be determined at our sole
          discretion.
        </p>
      </section>

      <section>
        <h2>12. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at{" "}
          <a href="mailto:support@avroapp.com">support@avroapp.com</a>.
        </p>
      </section>
    </div>
  );
}

export default TermsOfService;
